import { realApi } from './api';

// Solo cubre el caso normal (sin incidencia/walkover): 1 a 3 sets con
// puntos por set. Deja el partido en PROPUESTO — confirmarlo lo hace el
// comité, todavía sin pantalla propia en este frontend.
export const proponerResultado = (partidoId, sets) =>
  realApi.post(`/partidos/${partidoId}/resultado`, { sets });

// Corrige un partido ya existente (PENDIENTE, PROPUESTO o CONFIRMADO): PATCH
// sustituye del todo los sets guardados, así que hay que mandar siempre el
// conjunto completo que se quiere conservar, no solo el que cambió.
export const corregirPartido = (partidoId, datos) =>
  realApi.patch(`/partidos/${partidoId}`, datos);

// Sustituye del todo la alineación de un lado (LOCAL o VISITANTE): igual
// que con los sets, hay que mandar la lista completa que se quiere
// conservar de ese lado, no solo quien cambió.
export const corregirAlineacion = (partidoId, { lado, jugadores }) =>
  realApi.post(`/partidos/${partidoId}/alineacion`, { lado, jugadores });

// Solo funciona con el partido en PROPUESTO (confirmarPartido en el backend
// rechaza cualquier otro estado con 409). Si sigue en PENDIENTE hay que
// pasar antes por proponerResultado — ver el encadenado en Actas.js.
export const confirmarPartido = (partidoId) =>
  realApi.post(`/partidos/${partidoId}/confirmar`);

// Walkover (WO por lesión/incomparecencia/sanción, o partido no disputado):
// mismo endpoint que proponerResultado pero con incidencia + marcador
// manual en vez de sets. El backend exige partido.estado === PENDIENTE, así
// que solo tiene sentido antes de tocar nada más del partido. Deja el
// partido en PROPUESTO — hay que confirmarlo aparte, como un resultado
// normal.
export const registrarIncidencia = (partidoId, datos) =>
  realApi.post(`/partidos/${partidoId}/resultado`, datos);

// Requiere ADMIN o COMITE. No admite partidos ya CONFIRMADO o ANULADO (el
// backend responde 409). Pasa el partido directamente a APLAZADO, sin
// necesidad de confirmar.
// `aplazadoPor` es obligatorio (LOCAL | VISITANTE | AMBOS | LESION): de ello
// dependen el estado que ve el jugador y a quién se avisa. `fechaComunicacion`
// ('YYYY-MM-DD') es opcional y, si falta, el backend usa la de hoy.
export const aplazarPartido = (partidoId, { motivo, aplazadoPor, fechaComunicacion }) =>
  realApi.post(`/partidos/${partidoId}/aplazar`, { motivo, aplazadoPor, fechaComunicacion });

// Partido suelto fuera del round robin (amistoso, recuperación...). Igual
// que /aplazar, requiere ADMIN o COMITE. Es aditivo: no toca ni regenera el
// resto del calendario, solo inserta uno nuevo en PENDIENTE.
export const crearPartido = (datos) =>
  realApi.post('/partidos', datos).then((r) => r.datos);

// Descalificación del equipo: el partido no se juega, así que a diferencia
// de un walkover no hay ganador ni marcador manual que mandar. Mismas
// restricciones de estado que /aplazar (nada CONFIRMADO o ya ANULADO).
export const anularPartido = (partidoId, motivo) =>
  realApi.post(`/partidos/${partidoId}/anular`, { motivo });
